import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

import { TileDeleteButton } from "../Tiles/common/TileDeleteButton";
import { ImagePreviewTile } from "../Tiles/ImagePreviewTile/ImagePreviewTile";
import { type CoverFile } from "./types";

const classes = {
  deleteButton: "delete-button",
};

const Container = styled(Box)(() => ({
  position: "relative",
  [`&:hover .${classes.deleteButton}`]: {
    opacity: 1,
  },
}));

const DeleteButtonContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: theme.spacing(1),
  left: theme.spacing(1),
  opacity: 0,
  transition: "opacity 0.2s ease-in-out",
}));

interface SortableObjectTileProps {
  file: CoverFile;
  onDelete: () => void;
}

export const SortableObjectTile = (props: SortableObjectTileProps) => {
  const { file, onDelete } = props;

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: file.id,
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const handleAction = (e: React.MouseEvent, action: "DELETE") => {
    if (action === "DELETE") {
      onDelete();
    }
  };

  if (!file.previewUrl) {
    return null;
  }

  return (
    <Container>
      <Box
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...listeners}
        sx={{ cursor: "grab" }}
      >
        <ImagePreviewTile
          src={file.previewUrl}
          alt={file.name ?? "Cover image"}
        />
      </Box>
      <DeleteButtonContainer className={classes.deleteButton}>
        <TileDeleteButton onAction={handleAction} />
      </DeleteButtonContainer>
    </Container>
  );
};
